export default __webpack_public_path__ + "static/media/scanicon.711bcacf.svg";